<template>
    <v-container fluid class="container-white-box" >

        <template>
            <!-- BOTÓN MENU -->
            <v-menu 
                offset-y
                v-model="menuVisible"
                :close-on-content-click="false"
                :close-on-click="true"     
                min-width="600"
                max-width="800"        
                nudge-width="100"      
                nudge-bottom="20"   
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on">
                        Cargar datos
                    </v-btn>
                </template>
                
                <!-- LISTADO CON OPCIONES -->
                <v-list>
                    <!-- OPCIÓN 0. TÍTULO + BOTÓN DE CIERRE  -->
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="headline">
                                Información sobre contratos
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn icon small @click="menuVisible = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                    

                    <!-- OPCIÓN 1. Listado de contratos para un día. tiene desplegable -->
                    <v-list-group no-action prepend-icon="mdi-file-document">
                        <!-- Título -->
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Mostrar contratos activos según día</v-list-item-title>
                            </v-list-item-content>  
                        </template>
                        <!-- selección fecha -->
                        <v-list-item>
                            <v-menu
                            v-model="menuDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290"
                            min-width="290"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="selectedDate"
                                label="Fecha"
                                readonly
                                dense
                                v-bind="attrs"
                                v-on="on"
                                :rules="dateValidationRules"
                                />
                            </template>
                            <v-date-picker
                                v-model="selectedDate"
                                @input="menuDate = false"
                                :max="today"
                            />
                            </v-menu>
                        </v-list-item>
                         <!-- opción 2. ejecución.-->
                        <v-list-item @click="executeFetchContractsToPrint">
                            <v-list-item-icon>
                                <v-icon>
                                    mdi-pencil
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                Ejecutar
                            </v-list-item-title>
                            <v-list-item-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop="clearContractsToPrint">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>
                                        eliminar listado
                                    </span>
                                </v-tooltip>
                        </v-list-item-action>
                        </v-list-item>
                    </v-list-group>

                    <!-- OPCIÓN 2. CONTRATOS. tiene desplegable -->
                    <v-list-group no-action prepend-icon="mdi-chart-line">
                        <!-- Título -->
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Gráfica contratos</v-list-item-title>
                            </v-list-item-content>  
                        </template>
                        <!-- opciones del desplegable -->
                        <!-- opción 1. selección -->
                        <v-list-item>
                            <v-select
                            :items="years"
                            label="Año"
                            v-model="selectedYear"
                            dense
                            :hint="selectedYear === 'all' ? '⚠️ Puede tardar con todos los años' : ''"
                            persistent-hint
                            />
                        </v-list-item>
                        <!-- opción 2. selección -->
                        <v-list-item>
                            <v-select
                                :items="contractType"
                                label="Tipo contrato"
                                v-model="selectedContractType"
                                hide-details
                                dense
                            />
                        </v-list-item>
                        <!-- opción 2. ejecución de filtros -->
                        <v-list-item @click="executeFetchContracts">
                            <v-list-item-icon>
                                <v-icon>
                                    mdi-chart-line
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                Ejecutar
                            </v-list-item-title>
                            <v-list-item-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop="clearContracts">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>
                                        eliminar gráfico
                                    </span>
                                </v-tooltip>
                        </v-list-item-action>
                        </v-list-item>
                    </v-list-group>

                    <!-- OPCIÓN 3. CONECTORES TOTAL  -->
                    <v-list-item @click="executeFetchConnectorsInfo">
                        <v-list-item-icon>
                            <v-icon>
                                mdi-puzzle
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            Gráfica conectores
                        </v-list-item-title>
                        <v-list-item-action>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small v-bind="attrs" v-on="on" @click.stop="clearConnectorsInfo">
                                        <v-icon>
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>eliminar gráfico</span>
                            </v-tooltip>
                                
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        icon 
                                        small 
                                        v-bind="attrs" 
                                        v-on="on" 
                                        @click.stop="clearConnectorsCache">
                                        <v-icon>
                                            mdi-cached
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>eliminar caché</span>
                            </v-tooltip>
                            
                        </v-list-item-action>
                    </v-list-item>

                    <!-- OPCIÓN 4. CONECTORES POR MES  -->
                    <v-list-item @click="executeFetchConnectorsInfoPerMonth">
                        <v-list-item-icon>
                            <v-icon color="grey darken-1">
                                mdi-wrench
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            Gráfica conectores por mes
                        </v-list-item-title>
                        <v-list-item-subtitle class="development-note">
                            <span>Todavía en desarrollo</span>
                        </v-list-item-subtitle>
                        <v-list-item-action>
                            <v-btn icon small @click.stop="clearConnectorsInfoPerMonth">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>

                    <!-- OPCIÓN 5. CONTRATOS PROBLEMÁTICOS -->
                    <v-list-item @click="executeFetchProblematicContracts">
                        <v-list-item-icon>
                            <v-icon color="red darken-1">
                                mdi-alert-circle
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            Contratos problemáticos
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <span>Sin SC, discrepancias price/amount</span>
                        </v-list-item-subtitle>
                        <v-list-item-action>
                            <v-btn icon small @click.stop="clearProblematicContracts">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>

                    <!-- OPCIÓN 6. CRÉDITOS POR USAR -->
                    <v-list-item @click="executeFetchPendingCredits">
                        <v-list-item-icon>
                            <v-icon color="blue darken-1">
                                mdi-credit-card-outline
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            Créditos por usar
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <span>Contratos documents activos</span>
                        </v-list-item-subtitle>
                        <v-list-item-action>
                            <v-btn icon small @click.stop="clearPendingCredits">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-menu>

            
        </template>

        
        <!-- GRÁFICA CONTRACTES -->
        <div v-if="loadingContracts" class="loading-state">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            <p class="mt-4 text-subtitle-1 grey--text">Cargando datos de contratos...</p>
        </div>
        <div v-else-if="chartData" class="chart-container" style="height: 400px; position: relative;">
            <canvas ref="contractsChart"></canvas>
            <v-btn
                v-if="chartInstance"
                small
                color="primary"
                style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                @click="resetZoom"
            >
                <v-icon small left>mdi-magnify-close</v-icon>
                Reset Zoom
            </v-btn>
        </div>

        <!-- GRÁFICA CONNECTORS MÉS USATS GLOBAL -->
        <div v-if="loadingConnectors" class="loading-state" style="margin-top: 2rem">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            <p class="mt-4 text-subtitle-1 grey--text">Cargando datos de conectores...</p>
        </div>
        <div v-else-if="connectorChartSeries.length > 0" style="margin-top: 2rem">
            <br><br><br>
            <apexchart
                width="100%"
                height="350"
                type="bar"
                :options="connectorChartOptions"
                :series="connectorChartSeries"
            ></apexchart>
        </div>

        <!-- LISTADO DE CONTRATOS -->
        <v-card v-if="contractsToPrint.length" class="mt-4" outlined>
            <v-card-title class="text-h6 d-flex justify-space-between align-center">
                <span>
                    <v-icon left color="primary">mdi-file-document-multiple</v-icon>
                    Contratos para {{ selectedDate }}
                </span>
                <v-btn icon small @click="clearContractsToPrint">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-chip color="primary" label class="mb-2">
                    {{ contractsToPrint.length }} contratos activos
                </v-chip>
                <v-divider class="my-3"></v-divider>
                <v-data-table
                    :headers="contractsTableHeaders"
                    :items="contractsToPrint"
                    :items-per-page="25"
                    dense
                    class="contracts-table"
                >
                    <template v-slot:item.user__username="{ item }">
                        <a
                            :href="getAdminContractUrl(item.id)"
                            target="_blank"
                            class="contract-link"
                        >
                            {{ item.user__username }}
                            <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
                        </a>
                    </template>
                    <template v-slot:item.kind="{ item }">
                        <v-chip x-small :color="getContractKindColor(item.kind)" dark>
                            {{ getContractKindLabel(item.kind) }}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- CONTRATOS PROBLEMÁTICOS -->
        <div v-if="loadingProblematicContracts" class="loading-state" style="margin-top: 2rem">
            <v-progress-circular indeterminate color="red" size="64"></v-progress-circular>
            <p class="mt-4 text-subtitle-1 grey--text">Cargando contratos problemáticos...</p>
        </div>
        <v-card v-else-if="problematicContractsData" class="mt-4" outlined>
            <v-card-title class="text-h6 d-flex justify-space-between align-center">
                <span>
                    <v-icon left color="red">mdi-alert-circle</v-icon>
                    Contratos Problemáticos
                </span>
                <v-btn icon small @click="clearProblematicContracts">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <!-- Resumen -->
                <v-row class="mb-4">
                    <v-col cols="12" md="4">
                        <v-card outlined class="pa-3">
                            <div class="text-caption grey--text">Total contratos no trial</div>
                            <div class="text-h5">{{ problematicContractsData.summary.total_non_trial }}</div>
                            <div class="text-caption">
                                <span class="green--text">{{ problematicContractsData.summary.total_with_sc }} con Service Charge</span> |
                                <span class="orange--text">{{ problematicContractsData.summary.total_without_sc }} sin Service Charge (es un campo relativamente nuevo)</span>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card outlined class="pa-3">
                            <div class="text-caption grey--text">Sin Service Charge problemáticos, ya que al tener price y onboard generaron comisión</div>
                            <div class="text-h5 red--text">{{ problematicContractsData.summary.no_sc_problematics_total }}</div>
                            <div class="text-caption">
                                <span class="green--text">{{ problematicContractsData.summary.no_sc_problematics_kd }} KD</span> |
                                <span class="orange--text">{{ problematicContractsData.summary.no_sc_problematics_no_kd }} no KD</span>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card outlined class="pa-3">
                            <div class="text-caption grey--text">Precio de contrato y de Service Charge incongruentes</div>
                            <div class="text-h5 orange--text">{{ problematicContractsData.summary.price_diff_sc_total }}</div>
                            <div class="text-caption">
                                <span class="green--text">{{ problematicContractsData.summary.price_lt_sc_total }} price contract &lt; price service charge</span> |
                                <span class="orange--text">{{ problematicContractsData.summary.price_gt_sc }} price contract > price service charge</span>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Tabs con las diferentes listas -->
                <v-tabs v-model="activeProblematicTab" background-color="transparent" grow>
                    <v-tab>
                        Sin Service Charge - No Kit Digital
                        <v-chip x-small class="ml-2" color="red" dark>{{ problematicContractsData.contracts_no_sc_no_kd.length }}</v-chip>
                    </v-tab>
                    <v-tab>
                        Sin Service Charge - Kit Digital
                        <v-chip x-small class="ml-2" color="orange" dark>{{ problematicContractsData.contracts_no_sc_kd.length }}</v-chip>
                    </v-tab>
                    <v-tab>
                        Precio del Contrato > Precio del Service Charge
                        <v-chip x-small class="ml-2" color="red" dark>{{ problematicContractsData.contracts_price_gt_sc.length }}</v-chip>
                    </v-tab>
                    <v-tab>
                        Precio del Contrato &lt;  Precio del Service Charge (SC compartido en 2 contratos)
                        <v-chip x-small class="ml-2" color="blue" dark>{{ problematicContractsData.contracts_price_lt_sc_compartit.length }}</v-chip>
                    </v-tab>
                    <v-tab>
                        Precio del Contrato &lt;  Precio del Service Charge (SC no compartido)
                        <v-chip x-small class="ml-2" color="grey" dark>{{ problematicContractsData.contracts_price_lt_sc_no_compartit.length }}</v-chip>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeProblematicTab">
                    <!-- Sin SC No KD -->
                    <v-tab-item>
                        <v-data-table
                            :headers="problematicContractsHeaders"
                            :items="problematicContractsData.contracts_no_sc_no_kd"
                            :items-per-page="10"
                            dense
                            class="mt-2"
                        >
                            <template v-slot:item.id="{ item }">
                                <a :href="item.admin_url" target="_blank" class="contract-link">
                                    {{ item.id }}
                                    <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
                                </a>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <!-- Sin SC KD -->
                    <v-tab-item>
                        <v-data-table
                            :headers="problematicContractsHeaders"
                            :items="problematicContractsData.contracts_no_sc_kd"
                            :items-per-page="10"
                            dense
                            class="mt-2"
                        >
                            <template v-slot:item.id="{ item }">
                                <a :href="item.admin_url" target="_blank" class="contract-link">
                                    {{ item.id }}
                                    <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
                                </a>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <!-- Price > SC -->
                    <v-tab-item>
                        <v-data-table
                            :headers="problematicContractsHeadersWithSC"
                            :items="problematicContractsData.contracts_price_gt_sc"
                            :items-per-page="10"
                            dense
                            class="mt-2"
                        >
                            <template v-slot:item.id="{ item }">
                                <a :href="item.admin_url" target="_blank" class="contract-link">
                                    {{ item.id }}
                                    <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
                                </a>
                            </template>
                            <template v-slot:item.diff="{ item }">
                                <span class="red--text font-weight-bold">+{{ item.diff }}</span>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <!-- Price < SC compartit -->
                    <v-tab-item>
                        <v-data-table
                            :headers="problematicContractsHeadersWithSC"
                            :items="problematicContractsData.contracts_price_lt_sc_compartit"
                            :items-per-page="10"
                            dense
                            class="mt-2"
                        >
                            <template v-slot:item.id="{ item }">
                                <a :href="item.admin_url" target="_blank" class="contract-link">
                                    {{ item.id }}
                                    <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
                                </a>
                            </template>
                            <template v-slot:item.diff="{ item }">
                                <span class="blue--text">{{ item.diff }}</span>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <!-- Price < SC no compartit -->
                    <v-tab-item>
                        <v-data-table
                            :headers="problematicContractsHeadersWithSC"
                            :items="problematicContractsData.contracts_price_lt_sc_no_compartit"
                            :items-per-page="10"
                            dense
                            class="mt-2"
                        >
                            <template v-slot:item.id="{ item }">
                                <a :href="item.admin_url" target="_blank" class="contract-link">
                                    {{ item.id }}
                                    <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
                                </a>
                            </template>
                            <template v-slot:item.diff="{ item }">
                                <span class="grey--text">{{ item.diff }}</span>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>

                <!-- Info adicional -->
                <v-expansion-panels class="mt-4" flat>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <span class="text-caption">Información adicional sobre Service Charges</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-simple-table dense>
                                <tbody>
                                    <tr>
                                        <td>Total Service Charges</td>
                                        <td>{{ problematicContractsData.summary.total_service_charges }}</td>
                                    </tr>
                                    <tr>
                                        <td>SC compartidos (en >1 contrato)</td>
                                        <td>{{ problematicContractsData.summary.shared_service_charges }}</td>
                                    </tr>
                                    <tr>
                                        <td>Contratos con SC compartido</td>
                                        <td>{{ problematicContractsData.summary.contracts_with_shared_sc }}</td>
                                    </tr>
                                    <tr>
                                        <td>SC con amount 0 o null</td>
                                        <td>{{ problematicContractsData.summary.sc_amount_0_or_null }}</td>
                                    </tr>
                                    <tr>
                                        <td>Contratos con SC sin price</td>
                                        <td>{{ problematicContractsData.summary.with_sc_no_price }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                            <v-divider class="my-2"></v-divider>
                            <div class="text-caption grey--text">
                                <strong>Sin SC por tipo (no problemáticos):</strong>
                                Sage: {{ problematicContractsData.summary.no_sc_sage }} |
                                Concesiones: {{ problematicContractsData.summary.no_sc_concessions }} |
                                Traspasos: {{ problematicContractsData.summary.no_sc_traspassos }} |
                                Staff: {{ problematicContractsData.summary.no_sc_staff }}
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
        </v-card>

        <!-- CRÉDITOS POR USAR -->
        <div v-if="loadingPendingCredits" class="loading-state" style="margin-top: 2rem">
            <v-progress-circular indeterminate color="blue" size="64"></v-progress-circular>
            <p class="mt-4 text-subtitle-1 grey--text">Cargando créditos pendientes...</p>
        </div>
        <v-card v-else-if="pendingCreditsData" class="mt-4" outlined>
            <v-card-title class="text-h6 d-flex justify-space-between align-center">
                <span>
                    <v-icon left color="blue">mdi-credit-card-outline</v-icon>
                    Créditos por Usar
                    <span v-if="pendingCreditsData.last_update" class="text-caption grey--text ml-2">
                        (actualizado: {{ pendingCreditsData.last_update }})
                    </span>
                </span>
                <v-btn icon small @click="clearPendingCredits">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <!-- Resumen actual -->
                <v-row>
                    <v-col cols="12" md="3">
                        <v-card outlined class="pa-3 text-center">
                            <div class="text-caption grey--text">Créditos Pendientes</div>
                            <div class="text-h4 blue--text">{{ pendingCreditsData.total_pending_credits.toLocaleString() }}</div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card outlined class="pa-3 text-center">
                            <div class="text-caption grey--text">Contratos Activos</div>
                            <div class="text-h5">{{ pendingCreditsData.total_contracts.toLocaleString() }}</div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card outlined class="pa-3 text-center">
                            <div class="text-caption grey--text">Total Documentos</div>
                            <div class="text-h5">{{ pendingCreditsData.total_docs_num.toLocaleString() }}</div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-card outlined class="pa-3 text-center">
                            <div class="text-caption grey--text">Documentos Usados</div>
                            <div class="text-h5">{{ pendingCreditsData.total_used_docs.toLocaleString() }}</div>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Alerta si no hay datos -->
                <v-alert v-if="!pendingCreditsData.last_update" type="info" dense class="mt-3">
                    No hay snapshots guardados. Ejecuta el comando: python manage.py save_pending_credits_snapshot
                </v-alert>

                <!-- Gráfica de evolución -->
                <div v-if="pendingCreditsData" class="mt-4">
                    <div class="d-flex justify-space-between align-center mb-3 flex-wrap">
                        <div class="text-subtitle-2 grey--text mb-2">Evolución de Créditos Pendientes</div>
                        <div class="d-flex gap-2 flex-wrap align-center">
                            <v-btn small :outlined="creditsTimeFilter !== 'all'" color="blue" @click="setFilterAll">
                                Todo
                            </v-btn>
                            <v-btn small :outlined="creditsTimeFilter !== 'lastyear'" color="blue" @click="setFilterLastYear">
                                Último año
                            </v-btn>
                            <v-select
                                v-model="creditsYearFilter"
                                :items="availableYears"
                                label="Año"
                                dense
                                outlined
                                hide-details
                                clearable
                                style="max-width: 120px;"
                                @change="onYearFilterChange"
                            ></v-select>
                            <v-select
                                v-model="creditsMonthFilter"
                                :items="availableMonths"
                                label="Mes"
                                dense
                                outlined
                                hide-details
                                clearable
                                style="max-width: 150px;"
                                @change="onMonthFilterChange"
                            ></v-select>
                        </div>
                    </div>

                    <!-- Mensaje si no hay datos -->
                    <v-alert v-if="!pendingCreditsData.history || pendingCreditsData.history.length === 0" type="info" dense>
                        No hay datos para el período seleccionado
                    </v-alert>

                    <!-- Gráfica -->
                    <div v-else-if="pendingCreditsData.history.length > 1" class="chart-container" style="height: 300px; position: relative;">
                        <canvas ref="pendingCreditsChart"></canvas>
                    </div>

                    <!-- Mensaje si solo hay 1 dato -->
                    <v-alert v-else-if="pendingCreditsData.history.length === 1" type="info" dense>
                        Solo hay un snapshot para este período. Se necesitan al menos 2 puntos para mostrar la gráfica.
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>

        <!-- SISTEMA DE NOTIFICACIONES -->
        <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.color"
            :timeout="snackbar.timeout"
            bottom
            right
        >
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-bind="attrs"
                    @click="snackbar.show = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>

    </v-container>
</template>

<script>
import { query_dispatcher_2, query_dispatcher_get_2 } from '@/api/client';
import VueApexCharts from 'vue-apexcharts'
import Chart from 'chart.js/auto'
import 'chartjs-adapter-luxon'
import zoomPlugin from 'chartjs-plugin-zoom'

Chart.register(zoomPlugin)

export default{
    name: 'ContractsKPI',

    components:{
        apexchart: VueApexCharts
    },

    data(){
        return{
            numberOfContractsPerDay: [],
            chartOptions: {
                chart: {
                    id: 'contracts-per-day',
                    stacked: true,
                    animations: {
                        enabled: true,
                        speed: 300,
                        animateGradually: { enabled: false },
                        dynamicAnimation: {
                            enabled: false
                        }
                    },
                    toolbar: {
                        show: true,
                        tools: {
                            download: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true
                        }
                    },
                    zoom: {
                        enabled: true,
                        type: 'x',
                        autoScaleYaxis: true
                    },
                    events: {}
                },
                xaxis: {
                    type: 'datetime',
                    title: { text: 'Fecha' }
                },
                yaxis: {
                    title: { text: 'Contratos activos' },
                    decimalsInFloat: 0
                },
                title: {
                    text: 'Contratos activos por fecha',
                    align: 'left'
                },
                dataLabels: { enabled: false },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.7,
                        opacityTo: 0.3,
                        stops: [0, 90, 100]
                    }
                },
                tooltip: {
                    enabled: true,
                    shared: false,
                    followCursor: false,
                    intersect: false,
                    custom: function({ series, seriesIndex, dataPointIndex, w }) {
                        const value = series[seriesIndex][dataPointIndex];
                        const date = new Date(w.globals.seriesX[seriesIndex][dataPointIndex]);

                        // Formatear fecha: 01 Ene 2025
                        const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                        const formattedDate = `${date.getDate().toString().padStart(2, '0')} ${months[date.getMonth()]} ${date.getFullYear()}`;

                        return `
                            <div style="
                                background: white;
                                padding: 12px 16px;
                                border-radius: 6px;
                                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                                border: 1px solid #e0e0e0;
                                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                            ">
                                <div style="
                                    font-size: 11px;
                                    color: #666;
                                    margin-bottom: 4px;
                                    font-weight: 500;
                                ">${formattedDate}</div>
                                <div style="
                                    font-size: 14px;
                                    color: #1976d2;
                                    font-weight: 600;
                                ">${Math.round(value)} contratos activos</div>
                            </div>
                        `;
                    }
                },
                markers: {
                    size: 4,
                    strokeWidth: 2,
                    hover: {
                        size: 6
                    }
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    },
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                grid: {
                    borderColor: '#e7e7e7',
                    strokeDashArray: 4,
                    xaxis: {
                        lines: { show: false }
                    },
                    yaxis: {
                        lines: { show: true }
                    }
                }
            },
            chartSeries: [],
            chartData: null,
            chartInstance: null,
            selectedYear: new Date().getFullYear().toString(),
            selectedContractType:null,
            contractType: [
                {text: 'Todos los tipos de paquetes', value: null},
                {text: 'Paquete de Documentos', value: 'documents'},
                {text: 'Paquete de Bancos', value: 'banks'},
                {text: 'Paquete de Créditos Gestor Documental', value: 'credits'},
                {text: 'Paquete de Créditos Factura Electrónica', value: 'facturae_credits'},
            ],
            connectorChartOptions: {
                chart: {
                    id: 'connectors-per-month',
                    animations: {
                        enabled: true,
                        speed: 300,
                        animateGradually: { enabled: false }
                    },
                    toolbar: {
                        show: true,
                        tools: {
                            download: true,
                            zoom: false,
                            pan: false,
                            reset: false
                        }
                    }
                },
                xaxis: {
                    type: 'category',
                    title: { text: 'Número de usuarios' }
                },
                yaxis: {
                    title: { text: 'Tipo de conector' }
                },
                title: {
                    text: 'Conectores más utilizados',
                    align: 'left'
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px'
                    }
                },
                tooltip: {
                    shared: false,
                    intersect: true
                }
            },
            connectorChartSeries: [],
            menuVisible: false,
            noCache: false,
            contractsToPrint: [],
            contractsTableHeaders: [
                { text: 'Usuario', value: 'user__username', sortable: true },
                { text: 'Tipo', value: 'kind', sortable: true },
                { text: 'Inicio', value: 'start_date', sortable: true },
                { text: 'Fin', value: 'end_date', sortable: true },
            ],
            menuDate: false,
            selectedDate: null, // ISO "YYYY-MM-DD"
            loadingContracts: false,
            loadingConnectors: false,
            // Sistema de notificaciones
            snackbar: {
                show: false,
                message: '',
                color: 'success',
                timeout: 3000
            },
            // Contratos problemáticos
            loadingProblematicContracts: false,
            problematicContractsData: null,
            problematicContractsHeaders: [
                { text: 'ID', value: 'id', sortable: true },
                { text: 'Usuario', value: 'username', sortable: true },
                { text: 'Nombre', value: 'name', sortable: true },
                { text: 'Alta', value: 'who_signup', sortable: true },
                { text: 'Formador', value: 'who_trained', sortable: true },
                { text: 'Cierre', value: 'who_closed_sale', sortable: true },
                { text: 'Inicio', value: 'start_date', sortable: true },
                { text: 'Price', value: 'price', sortable: true },
            ],
            problematicContractsHeadersWithSC: [
                { text: 'ID', value: 'id', sortable: true },
                { text: 'Usuario', value: 'username', sortable: true },
                { text: 'Nombre', value: 'name', sortable: true },
                { text: 'Alta', value: 'who_signup', sortable: true },
                { text: 'Formador', value: 'who_trained', sortable: true },
                { text: 'Cierre', value: 'who_closed_sale', sortable: true },
                { text: 'Inicio', value: 'start_date', sortable: true },
                { text: 'Price', value: 'price', sortable: true },
                { text: 'SC Amount', value: 'sc_amount', sortable: true },
                { text: 'Diff', value: 'diff', sortable: true },
            ],
            activeProblematicTab: 0,
            // Créditos por usar
            loadingPendingCredits: false,
            pendingCreditsData: null,
            pendingCreditsChartInstance: null,
            creditsTimeFilter: 'all',
            creditsYearFilter: null,
            creditsMonthFilter: null
        }
    },

    computed: {
        availableYears() {
            if (!this.pendingCreditsData || !this.pendingCreditsData.available_years) return [];
            return this.pendingCreditsData.available_years.map(y => ({ text: y.toString(), value: y }));
        },
        availableMonths() {
            return [
                { text: 'Enero', value: 0 },
                { text: 'Febrero', value: 1 },
                { text: 'Marzo', value: 2 },
                { text: 'Abril', value: 3 },
                { text: 'Mayo', value: 4 },
                { text: 'Junio', value: 5 },
                { text: 'Julio', value: 6 },
                { text: 'Agosto', value: 7 },
                { text: 'Septiembre', value: 8 },
                { text: 'Octubre', value: 9 },
                { text: 'Noviembre', value: 10 },
                { text: 'Diciembre', value: 11 }
            ];
        },
        years() {
            const currentYear = new Date().getFullYear();
            const startYear = 2020;
            const yearsList = [{ text: 'Todos los años', value: 'all' }];

            for (let year = currentYear; year >= startYear; year--) {
                yearsList.push({
                    text: year.toString(),
                    value: year.toString()
                });
            }

            return yearsList;
        },
        today() {
            return new Date().toISOString().substr(0, 10);
        },
        dateValidationRules() {
            return [
                v => !!v || 'La fecha es obligatoria',
                v => /^\d{4}-\d{2}-\d{2}$/.test(v) || 'Formato de fecha inválido'
            ];
        }
    },

    methods: {
        // Método helper para mostrar notificaciones
        showNotification(message, color = 'success') {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },

        // Generar URL del admin de Django para un contrato
        getAdminContractUrl(contractId) {
            return `https://api.inmatic.ai/admin/adp/contract/${contractId}/change/`;
        },

        // Color del chip según el tipo de contrato
        getContractKindColor(kind) {
            const colors = {
                'documents': 'blue',
                'banks': 'green',
                'credits': 'orange',
                'facturae_credits': 'purple',
                'working_hours': 'teal',
            };
            return colors[kind] || 'grey';
        },

        // Etiqueta legible del tipo de contrato
        getContractKindLabel(kind) {
            const labels = {
                'documents': 'Documentos',
                'banks': 'Bancos',
                'credits': 'Gestor Documental',
                'facturae_credits': 'Factura Electrónica',
                'working_hours': 'Fichaje',
            };
            return labels[kind] || kind;
        },

        // Optimizar datos cuando hay demasiados puntos
        optimizeChartData(data) {
            const MAX_POINTS = 365; // Límite de puntos (aproximadamente 1 año diario)

            if (data.length <= MAX_POINTS) {
                return data; // No hace falta optimizar
            }

            // Si hay más de 365 puntos, agrupar por semanas
            if (data.length <= MAX_POINTS * 2) {
                return this.aggregateByWeek(data);
            }

            // Si hay MUCHOS datos (>2 años), agrupar por meses
            return this.aggregateByMonth(data);
        },

        aggregateByWeek(data) {
            const weeklyData = {};
            data.forEach(entry => {
                const date = new Date(entry.date);
                const monday = new Date(date);
                monday.setDate(date.getDate() - date.getDay() + 1);
                const weekKey = monday.toISOString().split('T')[0];

                if (!weeklyData[weekKey]) {
                    weeklyData[weekKey] = {
                        date: weekKey,
                        active_contracts: 0,
                        count: 0
                    };
                }
                weeklyData[weekKey].active_contracts += entry.active_contracts;
                weeklyData[weekKey].count += 1;
            });

            return Object.values(weeklyData).map(week => ({
                date: week.date,
                active_contracts: Math.round(week.active_contracts / week.count)
            }));
        },

        aggregateByMonth(data) {
            const monthlyData = {};
            data.forEach(entry => {
                const date = new Date(entry.date);
                const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;

                if (!monthlyData[monthKey]) {
                    monthlyData[monthKey] = {
                        date: monthKey,
                        active_contracts: 0,
                        count: 0
                    };
                }
                monthlyData[monthKey].active_contracts += entry.active_contracts;
                monthlyData[monthKey].count += 1;
            });

            return Object.values(monthlyData).map(month => ({
                date: month.date,
                active_contracts: Math.round(month.active_contracts / month.count)
            }));
        },

        async fetchContractsToPrint(){
            if (!this.selectedDate) return;

            try {
                let args= {}
                let query_args={}
                const [year, month, day] = this.selectedDate.split('-').map(Number);

                query_args["year"] = year
                query_args["month"] = month
                query_args["day"] = day

                args['args'] = query_args

                // Llamada al backend
                let res = await query_dispatcher_get_2.dispatch('get.all.contracts.to.print', args)
                this.contractsToPrint = res.results.contracts || [];

                const count = this.contractsToPrint.length;
                this.showNotification(`Se encontraron ${count} contratos para ${this.selectedDate}`, 'success');
            } catch (error) {
                console.error('Error al obtener contratos para imprimir:', error);
                this.contractsToPrint = [];
                this.showNotification('Error al obtener contratos. Por favor, inténtalo de nuevo.', 'error');
            }
        },
        async fetchContracts(){
            try {
                // Construimos argumentos para el backend (filtros de año y tipo de contrato)
                let args= {}
                let query_args={}
                if (this.selectedYear){
                    query_args['year']=this.selectedYear
                }
                if (this.selectedContractType){
                    query_args['contractType']=this.selectedContractType
                }
                args['args'] = query_args

                // Llamada al backend
                const startTime = performance.now();
                let res = await query_dispatcher_get_2.dispatch('get.all.contracts', args)
                const endTime = performance.now();
                const loadTime = ((endTime - startTime) / 1000).toFixed(2);

                // Asignamos los datos del backend al frontend
                this.numberOfContractsPerDay = res.results.number_of_contracts_per_day

                console.log(`📊 Backend devolvió ${this.numberOfContractsPerDay.length} registros en ${loadTime}s`);

                // Optimizar datos si hay demasiados puntos
                const optimizedData = this.optimizeChartData(this.numberOfContractsPerDay);
                const wasOptimized = optimizedData.length < this.numberOfContractsPerDay.length;

                console.log(`📈 Renderizando ${optimizedData.length} puntos en la gráfica`);

                // Asignar datos para Chart.js
                this.chartData = optimizedData;
                this.chartSeries = [{
                    name: 'Contratos activos',
                    data: optimizedData.map(entry => [entry.date, entry.active_contracts])
                }]

                if (this.numberOfContractsPerDay.length > 0) {
                    let message = 'Gráfica de contratos cargada correctamente';
                    if (wasOptimized) {
                        const originalCount = this.numberOfContractsPerDay.length;
                        const optimizedCount = optimizedData.length;
                        const granularity = originalCount > 730 ? 'meses' : 'semanas';
                        message = `Gráfica cargada (${originalCount} días → ${optimizedCount} ${granularity})`;
                    }
                    this.showNotification(message, 'success');
                } else {
                    this.showNotification('No se encontraron datos de contratos', 'info');
                }
            } catch (error) {
                console.error('Error al obtener contratos:', error);
                this.chartSeries = [];
                this.chartData = null;
                this.showNotification('Error al cargar gráfica de contratos', 'error');
            }
        },
        async fetchConnectorsInformation(){
            try {
                let args= {}
                let query_args={}
                if (this.noCache){
                    this.noCache=false
                    query_args['no_cache']=true
                }
                args['args'] = query_args
                // Llamada al backend
                let res = await query_dispatcher_get_2.dispatch('get.connectors.information', args)

                const connectorData = res.results.ordered_connector_counts;

                this.connectorChartSeries = [{
                    name: 'Usuarios',
                    data: Object.entries(connectorData).map(([name, value]) => ({ x: name, y: value }))
                }];

                const connectorCount = Object.keys(connectorData).length;
                if (connectorCount > 0) {
                    this.showNotification('Gráfica de conectores cargada correctamente', 'success');
                } else {
                    this.showNotification('No se encontraron datos de conectores', 'info');
                }
            } catch (error) {
                console.error('Error al obtener información de conectores:', error);
                this.connectorChartSeries = [];
                this.showNotification('Error al cargar gráfica de conectores', 'error');
            }
        },

        // async fetchConnectorsInformationPerMonth(){
        //     let args= {}
        //     let query_args={}
        //     args['args'] = query_args
        //     // Llamada al backend
        //     let res = await query_dispatcher_get_2.dispatch('get.connectors.information.per.month', args)

        //     const connectorData = res.results.kind_of_connectors_per_month;

        //     this.connectorChartSeries = [{
        //         name: 'Usuarios',
        //         data: Object.entries(connectorData).map(([name, value]) => ({ x: name, y: value }))
        //     }];

        // },


        // Métodos wrapper para ejecutar fetches con estados de carga
        async executeFetchContracts() {
            this.loadingContracts = true;
            try {
                await this.fetchContracts();
            } finally {
                this.loadingContracts = false;
            }
        },
        async executeFetchConnectorsInfo() {
            this.loadingConnectors = true;
            try {
                await this.fetchConnectorsInformation();
            } finally {
                this.loadingConnectors = false;
            }
        },
        async executeFetchConnectorsInfoPerMonth() {
            await this.fetchConnectorsInformationPerMonth();
        },
        async executeFetchContractsToPrint() {
            await this.fetchContractsToPrint();
        },
        async executeFetchProblematicContracts() {
            this.loadingProblematicContracts = true;
            try {
                await this.fetchProblematicContracts();
            } finally {
                this.loadingProblematicContracts = false;
            }
        },
        async fetchProblematicContracts() {
            try {
                let args = { args: {} };
                let res = await query_dispatcher_get_2.dispatch('get.problematic.contracts', args);
                this.problematicContractsData = res.results;

                const totalProblematic =
                    (res.results.summary.no_sc_problematics_total || 0) +
                    (res.results.summary.price_gt_sc || 0);

                if (totalProblematic > 0) {
                    this.showNotification(
                        `Se encontraron ${totalProblematic} contratos problemáticos`,
                        'warning'
                    );
                } else {
                    this.showNotification('No se encontraron contratos problemáticos', 'success');
                }
            } catch (error) {
                console.error('Error al obtener contratos problemáticos:', error);
                this.problematicContractsData = null;
                this.showNotification('Error al cargar contratos problemáticos', 'error');
            }
        },

        // Métodos para limpiar gráficos
        clearContracts() {
            this.chartSeries = [];
            this.chartData = null;
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }
            this.showNotification('Gráfica de contratos eliminada', 'info');
        },
        clearConnectorsInfo() {
            this.connectorChartSeries = [];
            this.showNotification('Gráfica de conectores eliminada', 'info');
        },
        clearConnectorsInfoPerMonth() {
            this.connectorChartSeries = [];
            this.showNotification('Gráfica de conectores por mes eliminada', 'info');
        },
        clearContractsToPrint(){
            this.contractsToPrint = [];
            this.showNotification('Listado de contratos eliminado', 'info');
        },
        clearProblematicContracts(){
            this.problematicContractsData = null;
            this.showNotification('Datos de contratos problemáticos eliminados', 'info');
        },

        // Créditos por usar
        async executeFetchPendingCredits() {
            this.loadingPendingCredits = true;
            try {
                await this.fetchPendingCredits();
            } finally {
                this.loadingPendingCredits = false;
            }
        },
        async fetchPendingCredits() {
            try {
                // Construir argumentos según los filtros activos
                let queryArgs = {
                    filter_type: this.creditsTimeFilter,
                    year: this.creditsYearFilter,
                    month: this.creditsMonthFilter
                };

                let args = { args: queryArgs };
                let res = await query_dispatcher_get_2.dispatch('get.pending.credits', args);
                this.pendingCreditsData = res.results;

                const pending = res.results.total_pending_credits || 0;
                const contracts = res.results.total_contracts || 0;
                this.showNotification(
                    `${pending.toLocaleString()} créditos pendientes en ${contracts} contratos`,
                    'success'
                );
            } catch (error) {
                console.error('Error al obtener créditos pendientes:', error);
                this.pendingCreditsData = null;
                this.showNotification('Error al cargar créditos pendientes', 'error');
            }
        },
        clearPendingCredits() {
            this.pendingCreditsData = null;
            this.creditsTimeFilter = 'all';
            this.creditsYearFilter = null;
            this.creditsMonthFilter = null;
            if (this.pendingCreditsChartInstance) {
                this.pendingCreditsChartInstance.destroy();
                this.pendingCreditsChartInstance = null;
            }
            this.showNotification('Datos de créditos pendientes eliminados', 'info');
        },
        setFilterAll() {
            this.creditsTimeFilter = 'all';
            this.creditsYearFilter = null;
            this.creditsMonthFilter = null;
            this.executeFetchPendingCredits();
        },
        setFilterLastYear() {
            this.creditsTimeFilter = 'lastyear';
            this.creditsYearFilter = null;
            this.creditsMonthFilter = null;
            this.executeFetchPendingCredits();
        },
        onYearFilterChange(year) {
            this.creditsTimeFilter = 'year';
            this.creditsMonthFilter = null; // Reset month when year changes
            this.executeFetchPendingCredits();
        },
        onMonthFilterChange(month) {
            this.creditsTimeFilter = 'month';
            if (!this.creditsYearFilter) {
                // Si no hay año seleccionado, usar el año actual
                this.creditsYearFilter = new Date().getFullYear();
            }
            this.executeFetchPendingCredits();
        },
        renderPendingCreditsChart(history) {
            if (!this.$refs.pendingCreditsChart || history.length < 2) return;

            // Destruir gráfico anterior si existe
            if (this.pendingCreditsChartInstance) {
                this.pendingCreditsChartInstance.destroy();
            }

            const ctx = this.$refs.pendingCreditsChart.getContext('2d');

            this.pendingCreditsChartInstance = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: history.map(h => h.date),
                    datasets: [{
                        label: 'Créditos Pendientes',
                        data: history.map(h => ({
                            x: h.date,
                            y: h.total_pending_credits
                        })),
                        borderColor: '#1976d2',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)',
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 3,
                        pointHoverRadius: 6
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: false },
                        title: { display: false },
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    return `${context.parsed.y.toLocaleString()} créditos pendientes`;
                                }
                            }
                        }
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: { day: 'dd MMM' }
                            },
                            title: { display: true, text: 'Fecha' }
                        },
                        y: {
                            title: { display: true, text: 'Créditos Pendientes' },
                            ticks: {
                                callback: function(value) {
                                    return value.toLocaleString();
                                }
                            }
                        }
                    }
                }
            });
        },

        // Eliminar caché de información de conectores
        clearConnectorsCache(){
            this.noCache = true;
            this.showNotification('Recargando datos sin caché...', 'info');
            this.fetchConnectorsInformation();
        },

        // Reset zoom del gráfico
        resetZoom() {
            if (this.chartInstance) {
                this.chartInstance.resetZoom();
                this.showNotification('Zoom restaurado', 'info');
            }
        },

        // Renderizar gráfico con Chart.js
        renderContractsChart(data) {
            try {
                console.log('🔧 renderContractsChart iniciado');

                if (!this.$refs.contractsChart) {
                    console.error('❌ Canvas ref not found');
                    return;
                }

                console.log('✅ Canvas encontrado');

                // Destruir gráfico anterior si existe
                if (this.chartInstance) {
                    console.log('🗑️ Destruyendo gráfico anterior');
                    this.chartInstance.destroy();
                }

                const ctx = this.$refs.contractsChart.getContext('2d');
                console.log('📊 Renderizando Chart.js con', data.length, 'puntos');
                console.log('📊 Datos sample:', data.slice(0, 3));

                this.chartInstance = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: data.map(entry => entry.date),
                    datasets: [{
                        label: 'Contratos activos',
                        data: data.map(entry => ({
                            x: entry.date,
                            y: entry.active_contracts
                        })),
                        borderColor: '#1976d2',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)',
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 0,
                        pointHoverRadius: 6,
                        pointHoverBackgroundColor: '#1976d2',
                        pointHoverBorderColor: '#fff',
                        pointHoverBorderWidth: 2
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                        mode: 'nearest',
                        axis: 'x',
                        intersect: false
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: 'Contratos activos por fecha',
                            align: 'start',
                            font: {
                                size: 16,
                                weight: 'normal'
                            },
                            padding: {
                                bottom: 20
                            }
                        },
                        zoom: {
                            zoom: {
                                wheel: {
                                    enabled: true,
                                    speed: 0.1
                                },
                                pinch: {
                                    enabled: true
                                },
                                mode: 'x'
                            },
                            pan: {
                                enabled: true,
                                mode: 'x'
                            },
                            limits: {
                                x: { min: 'original', max: 'original' }
                            }
                        },
                        tooltip: {
                            enabled: true,
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            titleColor: '#666',
                            bodyColor: '#1976d2',
                            borderColor: '#e0e0e0',
                            borderWidth: 1,
                            padding: 12,
                            displayColors: false,
                            callbacks: {
                                title: function(context) {
                                    // Usar parsed.x que es el timestamp correcto
                                    const timestamp = context[0].parsed.x;
                                    if (!timestamp) return 'Fecha no disponible';

                                    const date = new Date(timestamp);
                                    if (isNaN(date.getTime())) return 'Fecha inválida';

                                    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                                    return `${date.getDate().toString().padStart(2, '0')} ${months[date.getMonth()]} ${date.getFullYear()}`;
                                },
                                label: function(context) {
                                    const value = context.parsed.y;
                                    if (value === undefined || value === null || isNaN(value)) {
                                        return 'Datos no disponibles';
                                    }
                                    return `${Math.round(value)} contratos activos`;
                                }
                            }
                        }
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'month',
                                displayFormats: {
                                    month: 'MMM yyyy'
                                }
                            },
                            title: {
                                display: true,
                                text: 'Fecha'
                            },
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            beginAtZero: false,
                            title: {
                                display: true,
                                text: 'Contratos activos'
                            },
                            ticks: {
                                precision: 0
                            },
                            grid: {
                                color: 'rgba(0, 0, 0, 0.05)'
                            }
                        }
                    }
                }
            });

            console.log('✅ Chart.js creado exitosamente');

            } catch (error) {
                console.error('❌ Error al renderizar Chart.js:', error);
                console.error('Stack:', error.stack);
            }
        }
    },

    watch: {
        chartData(newData) {
            console.log('📌 chartData watcher activado', newData ? newData.length : 0, 'puntos');
            if (newData && newData.length > 0) {
                this.$nextTick(() => {
                    console.log('📌 Primera $nextTick');
                    this.$nextTick(() => {
                        console.log('📌 Segunda $nextTick ejecutando renderContractsChart');
                        this.renderContractsChart(newData);
                    });
                });
            }
        },
        pendingCreditsData(newData) {
            if (newData && newData.history && newData.history.length > 1) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.renderPendingCreditsChart(newData.history);
                    });
                });
            }
        }
    },

    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
        if (this.pendingCreditsChartInstance) {
            this.pendingCreditsChartInstance.destroy();
        }
    }

}
</script>

<style>
.container-white-box {
    padding: 20px;
    border-radius: 8px;
    min-height: 200px;
    min-width: 300px;
    background-color: #f8f8f8;
    height: 100%;
    position:absolute;
    overflow-y:auto;
}
.chart-container {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    box-sizing: border-box;
    padding: 10px;
}
.development-note span {
    color: #ff9800;
    font-style: italic;
}
.contracts-table {
    max-height: 400px;
    overflow-y: auto;
}
.contract-link {
    color: #1976d2;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
}
.contract-link:hover {
    text-decoration: underline;
}
.loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    min-height: 300px;
}
</style>
